var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.have),expression:"have"}],class:{selected:_vm.value==_vm.select.value},on:{"click":function($event){return _vm.sel(_vm.value)}}},[(_vm.haveslot)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3215feda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/leevueplugin/src/LeeOption.vue
// module id = J8AU
// module chunks = 170